import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import {
  createStackHeaderNavigator,
  ModalCloseButton,
} from "@towersystems/roam-common-native";
import { ProductTagsLlmQuickWinRootParamList } from "../../../../types";
import React from "react";
import { ScreenContext } from "./common";
import { useFormContext } from "react-hook-form";
import { ProductFormValues } from "../../components/ProductForm/types";
import { ProductTagsReviewScreen } from "./ProductTagsReviewScreen";

export type ProductTagsLlmQuickWinRootScreenProps = StackScreenProps<
  any,
  "ProductTagsLlmQuickWinRootScreen"
>;

const StackNavigator =
  createStackHeaderNavigator<ProductTagsLlmQuickWinRootParamList>();

export const ProductTagsLlmQuickWinRootScreen = ({
  navigation,
}: ProductTagsLlmQuickWinRootScreenProps) => {
  const { setValue: setProductFormValue, getValues } =
    useFormContext<ProductFormValues>();

  // need to use a screen context so the child form does not overwrite the parent form context
  const handleOnSubmit = (newTags: string[]) => {
    setProductFormValue("tags", newTags, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });
    navigation.pop();
  };

  return (
    <ScreenContext.Provider
      value={{
        onSubmit: handleOnSubmit,
        originalFormValues: getValues(), // incase we need other data
      }}
    >
      <StackNavigator.Navigator
        screenOptions={{
          headerShown: true,
          headerLeft: () => <ModalCloseButton type="Cancel" />,
          animationEnabled: true,
          cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
          title: "",
        }}
      >
        <StackNavigator.Screen
          name="ProductTagsReviewScreen"
          component={ProductTagsReviewScreen}
        />
      </StackNavigator.Navigator>
    </ScreenContext.Provider>
  );
};
